import Vue from 'vue'

const role = {
  state: {
    role: [],
    selectedRole: {},
  },

  getters: {
    role(state) {
      return state.role
    },
    selectedRole(state) {
      return state.selectedRole
    },
  },

  mutations: {
    role(state, payload) {
      state.role = payload
    },
    selectedRole(state, payload) {
      state.selectedRole = JSON.parse(JSON.stringify(payload))
    },
  },

  actions: {
    setSelectedRole(context, payload) {
      context.commit('selectedRole', payload)
    },
    loadRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'Role'
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('role', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    loadSelectedRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = 'Role/' + payload
        Vue.prototype.$axios.get(url).then(
          (res) => {
            context.commit('selectedRole', res.data)
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    updateRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Role/${payload.ID}`
        Vue.prototype.$axios.put(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'role updated'},
              {root: true}
            )
            //if you will always need to reload the list after an update
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadRole')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    createRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Role`
        Vue.prototype.$axios.post(url, payload).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'role created'},
              {root: true}
            )
            //if you will always need to reload the list after an item is created
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadRole')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
    saveRole(context, payload) {
      return new Promise((resolve, reject) => {
        if (payload.ID > 0) {
          context.dispatch('updateRole', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        } else {
          context.dispatch('createRole', payload).then(
            (res) => resolve(res),
            (err) => reject(err)
          )
        }
      })
    },
    deleteRole(context, payload) {
      return new Promise((resolve, reject) => {
        const url = `Role/${payload.ID}`
        Vue.prototype.$axios.delete(url).then(
          (res) => {
            context.dispatch(
              'messages/toastMessage',
              {color: 'success', message: 'role deleted'},
              {root: true}
            )
            //if you will always need to reload the list after a delete
            //you can uncomment out the following dispatch line.
            //Alternatively you can reload whatever object you need
            //when the promise resolves in the component that called it.
            //context.dispatch('loadRole')
            resolve(res)
          },
          (err) => {
            console.error(err)
            context.dispatch('errors/handleError', err, {root: true})
            reject(err)
          }
        )
      })
    },
  },
}

export default role
